import { ROLES, TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';
import { Icons, MenuItem } from '@silverfort/sf-components';
import { LogicalItemsTypes } from '../../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { isUserPermitted } from '../../../TowerMenu/TowerMenuUtils';
import { useSassRestrictions } from '../../../context/contexts/SassRestrictionsContext';

export const UniversalMfaMenuItems = ({
    handleMenuItemSelection,
    getTowerMenuHref,
    userData,
    ...props
}: LogicalItemsTypes) => {
    const { restrictedSaasSupportMode } = useSassRestrictions();

    return (
        <MenuItem id={TOWER_MENU_ITEMS.UNIVERSAL_MFA} ItemIcon={Icons.ShieldInnerLock} title="Universal MFA" {...props}>
            <MenuItem
                disabled={restrictedSaasSupportMode}
                href={getTowerMenuHref(TOWER_MENU_ITEMS.UNIVERSAL_MFA_DASHBOARD)}
                id={TOWER_MENU_ITEMS.UNIVERSAL_MFA_DASHBOARD}
                title="Dashboard"
            />
            <MenuItem
                disabled={restrictedSaasSupportMode || !isUserPermitted(userData, 'users', ROLES.VIEWER.value)}
                onClick={(id) => handleMenuItemSelection(id)}
                id={TOWER_MENU_ITEMS.PROTECTION_USER_MANAGEMENT}
                title="MFA User Management"
            />
        </MenuItem>
    );
};
